import React from 'react';

const BANNER_ITEMS = [
  { text: 'क्या शादी में हो रही है देरी? अभी परामर्श लें', icon: '💍' },
  { text: 'करियर में सफलता चाहिए? जानिए ग्रहों का प्रभाव', icon: '📈' },
  { text: 'पैसों की समस्या? धन योग जानें', icon: '💰' },
  { text: 'Free Kundli Analysis | निःशुल्क कुंडली विश्लेषण', icon: '📜' },
  { text: 'वास्तु दोष से परेशान? समाधान पाएं', icon: '🏠' },
  { text: 'शनि साढ़ेसाती चल रही है? उपाय जानें', icon: '🪐' },
  { text: 'संतान सुख नहीं? ज्योतिषीय उपाय', icon: '👶' },
  { text: 'पति-पत्नी में अनबन? समाधान मिलेगा', icon: '❤️' },
  { text: '33+ Years Experience | 33,000+ Satisfied Clients', icon: '⭐' },
  { text: 'Daily Panchang & Rahukaal | रोज़ का पंचांग', icon: '📅' },
];

export default function RunningBanner() {
  const items = [...BANNER_ITEMS, ...BANNER_ITEMS];

  return (
    <div className="relative overflow-hidden py-3 bg-gradient-to-r from-[#5a1a2e] via-[#3d101e] to-[#5a1a2e] border-y border-gold/10" data-testid="running-banner">
      <div className="flex animate-scroll whitespace-nowrap">
        {items.map((item, i) => (
          <a
            key={i}
            href="#book-consultation"
            className="inline-flex items-center gap-2 mx-8 text-sm hover:text-gold transition-colors shrink-0"
          >
            <span className="text-base">{item.icon}</span>
            <span className="text-gold/80 font-medium">{item.text}</span>
            <span className="text-gold/30">|</span>
          </a>
        ))}
      </div>

      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 40s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}
